module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_iterators.js
// module id = 26
// module chunks = 22